<template>
  <IQOS :title="$t('inside.halls.title')">
    <div class="sections-editor">
      <div class="sections-head">
        <h2 class="c-white head-no">№</h2>
        <h2 class="c-white head-title">{{$t('inside.halls.halln')}}</h2>
        <h2 :class="editing ? 'ml-0 c-white head-tables':'c-white head-tables'">{{$t('inside.halls.tables')}}</h2>
      </div>
      <div class="single-section" v-for="(section,index) in sections" :key="index">
        <h3 class="section-number-input c-white">{{ index + 1}}</h3>
        <BaseInput
          class="section-name-input"
          v-model="section.name"
          :placeholder="$t('inside.halls.hall_name')"
          :readonly="!editing"
        />
        <BaseInput
          class="section-table-input"
          v-model.number="section.tables"
          placeholder="10"
          :readonly="!editing"
        />
        <img
          class="delete-button"
          src="/icons/del.svg"
          @click="removeSection(index)"
          v-if="editing"
        />
      </div>
      <button class="square-button w-100" @click="addSection" v-if="editing && sections.length < 10">+ {{$t('inside.halls.hall')}}</button>
    </div>

    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";

export default {
  data() {
    return {
      editing: false,
      sections: []
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.resetValues();
    },
    resetValues() {
      this.sections = (this.$store.state.cafe.sections || []).slice();
    },
    addSection() {
        this.sections.push({
            name: null,
            tables: 1
        });
    },
    onEditFinish() {
        this.$store.commit('setCafeSections', this.sections);
        this.$store.dispatch('saveCafe');

        this.editing = false;
    },
    removeSection(index) {
      this.sections.splice(index, 1);
    }
  },
  mounted() {
    this.resetValues();
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput
  }
};
</script>

<style scoped>
h2 {
  margin-bottom: 0;
  font-size:2.7vh;
}

.single-section {
  margin-top: 2.2vh;
  align-items: center;
  display: flex;
}

.delete-button {
  height: 3.7vh;
  margin-left: 2vh;
  width: auto;
  cursor: pointer;
}

.section-name-input {
  width: 55%;
  height: 2.22vh;
  padding: 2vh 0;
  margin-left: 2vh;
}

.section-table-input {
  width: 35%;
  height: 2.22vh;
  padding: 2vh 0;
  margin-left: 2vh;
}

.section-number-input {
  width: 8%;
  line-height: normal;
  font-size: 3.5vh;
}

.sections-head {
  display: flex;
}

.head-tables {
  width: auto;
  margin-left: 3vh;
}

.head-title {
  width: 51%;
  margin-left: 2.2vh;
}
</style>